import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {User} from "../../../objects/user";
import {ListItem} from "../../../objects/listItem";
import {FormControl, FormGroup} from "@angular/forms";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {FS3Notification} from "../../../objects/notification";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";

@Component({
  selector: 'app-user-purchases-popup',
  templateUrl: './user-purchases-popup.component.html',
  styleUrls: ['./user-purchases-popup.component.css']
})
export class UserPurchasesPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  profile: User;
  pickList: object[] = [];
  pickItemsLoading: boolean;
  purchases: ListItem[];
  errorMessages: string[] = [];
  trainers: ListItem[];
  state: string = 'default';
  mode: string = 'show_purchases';
  errMsg: string = '';

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) { }

  protected profileID: number
  ngOnInit(): void {
    this.profile = this.payload['item']['itemFullData'] as User;
    this.profileID = this.payload['item']['itemFullData']['id'];
    if(this.payload['mode'] == 'show_proposals') {
      this.mode = 'show_proposals';
      this.loadUserProposals();
    } else {
      this.loadUserPurchases();
    }
  }

  protected loadGroupTrainers() { //for trainer display in clips
    this.application.apiService.getGroupTrainers()
      .subscribe(
        data => this.handleTrainers(data)
      )
  }
  private handleTrainers(data) {
    this.trainers = data;
    this.purchases.forEach((purchaseItem, idx) => {
      let purchase = purchaseItem['itemFullData']
      purchase['usage'].forEach((service, jdx) => {
        if(service['trainer_id']) {
          let foundTrainer = this.trainers.find(trainer => trainer['itemFullData']['id'] == service['trainer_id'])
          service['trainer_name'] = foundTrainer ? foundTrainer['itemFullData']['shipping_name'] : 'deleted: '+service['trainer_id'];
        }
      })
    })

  }

  protected loadUserPurchases() {
    this.state = 'loading';
    this.application.apiService.getProfilePurchases(this.profileID)
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  protected loadUserProposals() {
    this.state = 'loading';
    this.application.apiService.getProfileProposals(this.profileID)
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  private handleItems(data) {
    this.purchases = data;
    this.addFormControls()
    this.state = 'default'
    this.loadGroupTrainers(); //will update services with trainer_name
  }

  public addFormControls(): void {
    this.purchases.forEach((purchaseItem, idx) => {
      let purchase = purchaseItem['itemFullData']
      let d = new Date();
      d.setTime(purchase['expire_time']*1000);
      const purchaseExpiryControl = new FormControl();
      if(purchase['never_expire'] == 'N') purchaseExpiryControl.setValue(d);
      this.componentForm.addControl('purchaseExpiryControl_'+idx, purchaseExpiryControl);
      if(this.mode == 'show_proposals') {
        const purchaseCustomPriceControl = new FormControl();
        purchaseCustomPriceControl.setValue(purchase['custom_price']);
        this.componentForm.addControl('purchaseCustomPriceControl_'+idx, purchaseCustomPriceControl);
        const purchaseListPriceControl = new FormControl();
        purchaseListPriceControl.setValue(purchase['list_price']);
        this.componentForm.addControl('purchaseListPriceControl_'+idx, purchaseListPriceControl);
      }
      purchase['usage'].forEach((service, jdx) => {
        let packageUsageQtyControl = this.componentForm.get('packageUsageQtyControl_'+idx+'_'+jdx)
        if(!packageUsageQtyControl) {
          packageUsageQtyControl = new FormControl();
          this.componentForm.addControl('packageUsageQtyControl_'+idx+'_'+jdx, packageUsageQtyControl);
        }
        packageUsageQtyControl.setValue(service['used_qty']);

        let packageLimitQtyControl = this.componentForm.get('packageLimitQtyControl_'+idx+'_'+jdx)
        if(!packageLimitQtyControl) {
          packageLimitQtyControl = new FormControl();
          this.componentForm.addControl('packageLimitQtyControl_'+idx+'_'+jdx, packageLimitQtyControl);
        }
        packageLimitQtyControl.setValue(service['qty']);

        if(service['another_usage_reference']) {
          packageUsageQtyControl.disable();
          packageLimitQtyControl.disable();
        }
      })
    })
  }

  private handleItemsError(error) {
    this.pickItemsLoading = false;
    this.state = 'error';
    this.errMsg = error.errMsg;
  }

  public pickService(): void {
    this.pickList = [];
    this.pickItemsLoading = true;
    this.application.apiService.getGroupPackages()
      .subscribe(
        data => this.gotPackages(data),
        error => this.handleItemsError(error))
  }
  public gotPackages(data): void {
    data['packages'].map(item => {
      this.pickList.push(item);
    });
    this.pickItemsLoading = false;
    this.pickServicePopup(data['packages'],data['trainers']);
  }
  public pickServicePopup(packages,trainers): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'service-picker',
        payload: {packages: packages, trainers: trainers, profileID: this.profileID, mode: this.mode},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload && dialogPayload['saved']) {
          this.handleItems(dialogPayload['new_data'])
        }
      })
  }

  public showPromoPopup(idx): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'message-popup',
        payload: {old_message: this.purchases[idx]['itemFullData']['proposal_message']},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload && dialogPayload['message']) {
          console.log('afterClosed',dialogPayload['message']);
          this.saveService(idx,dialogPayload['message'])
        }
      })
  }

  public saveService(idx,message = ''): void {
    let purchaseItem = this.purchases[idx]['itemFullData'];
    purchaseItem['expire_time'] = this.componentForm.get('purchaseExpiryControl_'+idx).value.getTime()/1000;
    if(this.mode == 'show_proposals') {
      if(!this.componentForm.get('purchaseCustomPriceControl_'+idx).value || !parseFloat(this.componentForm.get('purchaseCustomPriceControl_'+idx).value)) {
        this.errorMessages[idx] = AppComponent.getLabel('proposal_custom_price_error');
        return;
      }
      purchaseItem['custom_price'] = parseFloat(this.componentForm.get('purchaseCustomPriceControl_'+idx).value);
      purchaseItem['list_price'] = parseFloat(this.componentForm.get('purchaseListPriceControl_'+idx).value);
    }
    // if(this.mode == 'show_proposals') {
    //   this.componentForm.addControl('purchaseCustomPriceControl_'+idx, purchaseCustomPriceControl);
    // }
    purchaseItem['usage'].forEach((service, jdx) => {
      service['used_qty'] = this.componentForm.get('packageUsageQtyControl_'+idx+'_'+jdx).value;
      service['qty'] = this.componentForm.get('packageLimitQtyControl_'+idx+'_'+jdx).value;
    })
    this.pickItemsLoading = true;
    let action = 'update';
    if(message) {
      action = 'send_proposal_message';
      purchaseItem['proposal_message'] = message;
    }
    this.application.apiService
      .saveProfilePurchase(this.profileID,purchaseItem,action)
      .subscribe(
        data => this.purchaseUpdated(idx, data),
        error => this.handleItemsError(error))
  }
  public deleteService(idx): void {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('delete_confirmation_popup_title'),
        message: AppComponent.getLabel('delete_confirmation_popup_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          this.pickItemsLoading = true;
          this.application.apiService
            .saveProfilePurchase(this.profileID,this.purchases[idx]['itemFullData'],'delete')
            .subscribe(
              data => this.purchaseDeleted(idx, data),
              error => this.handleItemsError(error))
        }
      })
  }

  public purchaseUpdated(idx, data): void {
    let notification = new FS3Notification();
    notification.type = 'success';
    notification.text = 'Updated!';
    this.sharedDataService.pushNotification(notification);
    this.pickItemsLoading = false;
    //this.purchases.splice(idx,1);
  }
  public purchaseDeleted(idx, data): void {
    let notification = new FS3Notification();
    notification.type = 'success';
    notification.text = 'Updated!';
    this.sharedDataService.pushNotification(notification);
    this.pickItemsLoading = false;
    this.purchases.splice(idx,1);
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }
  }

  public onNoClick(): void {
    this.close.emit()
  }

}
